module.exports = __webpack_public_path__ + "3af44a6e434c403b3fdd9b165fab17a5.svg";